import React, {useContext, useState} from 'react'
import { AuthContext } from '../context/AuthProvider';
import environment from '../utils/environment'

const useFetch = () =>{
    const { jwt } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false)

    const buildCustomFetch = method => {
        const customFetch = async (path, body) => {
            const url = `${environment.backendUrl}${path}`;

            console.log('useFetch', method, url, JSON.stringify(body))

            const request = {
                method: method,
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            }
            if(body){
                request.body = JSON.stringify(body)
                request.headers['Content-Type'] = 'application/json'
            }

            setIsLoading(true)
            const response = await fetch(url, request);
            setIsLoading(false)

            if (!response.ok) {
                const output = await response.text()
                console.error('useFetch', 'failed with', output)
                throw new Error(`Error fetching data ${url}`);
            } else {
                const data = await response.json();
                return data
            }
        }
        return customFetch
    }

    const doGet = buildCustomFetch('GET')
    const doPost = buildCustomFetch('POST')
    const doPut = buildCustomFetch('PUT')
    const doDelete = buildCustomFetch('DELETE')

    return {
        doGet,
        doPost,
        doPut,
        doDelete,
        get: doGet,
        post: doPost,
        put: doPut,
        delete: doDelete,
        isLoading
    }
}

export default useFetch